export const ADMIN_ROLE = 1;
export const DSO_STAFF = 2;
export const ADMISSION_STAFF = 3;
export const ACADEMIC_COORDINATOR_STAFF = 4;
export const STUDENT_SERVICES_STAFF = 5;
export const TEACHER_ROLE = 6;
export const FINANCIAL_STAFF = 7;
export const FINANCIAL_VIEWER_STAFF = 8;
export const PARTNERSHIPS_STAFF = 9;
export const HUMAN_RESOURCES_STAFF = 10;

export const getRoleClassName = (roleName) => {
    if (!roleName) return '';
    switch (roleName.toLowerCase()) {
        case 'admin':
            return 'staff-role-admin';
        case 'teacher':
            return 'staff-role-teacher';
        case 'admissions officer':
            return 'staff-role-admission';
        case 'student services':
            return 'staff-role-student-services';
        case 'financial officer':
            return 'staff-role-financial';
        case 'partnerships manager':
            return 'staff-role-partnerships';
        case 'human resources':
            return 'staff-role-human-resources';
        case 'academic coordinator':
            return 'staff-role-academic-coordinator';
        case 'dso':
            return 'staff-role-dso';
        case 'financial viewer':
            return 'staff-role-financial-viewer';
        default:
            return '';
    }
};
